const BookingEndPoint = {
  registerBooking: {
    url: `/booking`,
    method: "POST",
  },
  allBookingList: {
    url: `/bookings`,
    method: "GET",
  },
  tripPaymentList: {
    url: "/trip-payment-list",
    method: "GET",
  },
  bookingDetail: (id) => ({
    url: `/booking/${id}`,
    method: "GET",
  }),
  checkPromocode: (id) => ({
    url: `/trip/coupon/${id}`,
    method: "GET",
  }),
  updateBookingStatus: {
    url: "/booking-status",
    method: "PUT",
  },
  transferMoney: {
    url: `/booking-payment-status`,
    method: "PUT",
  },
  refundStatus: {
    url: `/refund-status`,
    method: "PUT",
  },
};

export default BookingEndPoint;
